import { DEFAULT_FILTER_PARAMETERS } from '@helpers/constants';
import { WorkerState } from './models';

export const defaultState: WorkerState = {
  featureFlags: {},
  currentTdoId: undefined,
  downloadingJobs: [],
  transcription: undefined,
  speakerSeparation: undefined,
  corsight: undefined,
  mediaDuration: 1,

  audioRedactionEdits: [],
  voiceMaskEdits: [],
  backgroundBlurEdits: [],
  selectedPolyGroups: {},
  udrAsset: {
    boundingPolys: {},
  },
  detectionEngineResultsAssetId: null,
  assetCheckpoint: 0,
  openedAssetCheckpoint: 0,
  voiceMaskMediaUrl: undefined,
  mediaDataUrl: undefined,
  mediaDataContainerId: undefined,
  tdoIsChanged: false,
  highlightedOverlay: undefined,

  lastAssignedClusterId: undefined,
  lastUdrGroupsWithUpdatedClusterAssignment: undefined,
  lastDetectionGroupsWithUpdatedClusterAssignment: undefined,

  tdo: undefined,
  clusterMap: {},
  groupMap: {},
  subsegmentMap: {},
  objectMap: {},
  detectionGaps: {},
  filterParameters: DEFAULT_FILTER_PARAMETERS,
  dataFetchedForDetectionType: {
    laptop: false,
    head: false,
    poim: false,
    licensePlate: false,
    card: false,
    notepad: false,
    person: false,
  },
  history: {
    past: [],
    future: [],
  },
};
